export const signIn = (payload: { login: string, password: string }) => ({
    type: "@saga/SIGN_IN",
    payload
});

